import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */

i18next.addResources(locales.EN, 'DOCUMENTS_TYPES_FORM', {
  TITLE: 'Documents types',
  NAME: 'Name',
  SUBMIT_BUTTON: 'Save',
  LOADING: 'Loading...',
});

/* ------------------------------------- Spanish ------------------------------------- */

i18next.addResources(locales.ES, 'DOCUMENTS_TYPES_FORM', {
  TITLE: 'Tipos de documentos',
  NAME: 'Nombre',
  SUBMIT_BUTTON: 'Guardar',
  LOADING: 'Cargando...',
});
